import React from 'react'
import { Typography } from '@material-ui/core'
import { AccordionSummaryViewType, MyAccordionCtrlType } from './accordionType'
import useAccordion from './useAccordion'
import { withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const Accordion = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
    root: {
        backgroundColor: '#ffffff',
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails)

const MyAccordionView: React.FC<AccordionSummaryViewType> = ({
    title,
    children,
    titleIcon,
    noPadding,
    renderTitle,
    defaultExpanded = true,
}) => {
    return (
        <Accordion square onChange={() => {}} defaultExpanded={defaultExpanded}>
            <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
                expandIcon={<ExpandMoreIcon color={'primary'} />}
            >
                {renderTitle ? (
                    renderTitle
                ) : (
                    <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                        {title}
                        {titleIcon && (
                            <>
                                &nbsp;
                                {titleIcon()}
                            </>
                        )}
                    </Typography>
                )}
            </AccordionSummary>
            <AccordionDetails style={noPadding ? { padding: '0px' } : undefined}>{children}</AccordionDetails>
        </Accordion>
    )
}

let MyAccordionCtrl: React.FC<MyAccordionCtrlType> = ({ ...others }) => {
    const myAutocomplete = useAccordion(others)
    return <MyAccordionView {...myAutocomplete} {...others} />
}

export default MyAccordionCtrl
